import * as Cookies from 'js-cookie'

export enum SessionSettingsCookie {
  Shipping = 'shippingCountry',
  Region = 'chosenSubsite',
  Currency = 'currency',
}

export const getSessionSettingsCookie = (
  type: SessionSettingsCookie,
  subsite: string,
): string => {
  return Cookies.get(`${subsite}_${type}_V6`)
}

export const setSessionSettingsCookie = (
  type: SessionSettingsCookie,
  subsite: string,
  value: string,
  domain: string,
) => {
  Cookies.remove(`${subsite}_${type}_V6`)
  Cookies.set(`${subsite}_${type}_V6`, value, { domain })
}
